/* eslint-disable
    no-return-assign,
    one-var
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS103: Rewrite code to no longer use __guard__
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import Backbone from 'backbone';
import * as d3 from 'd3';
import $ from 'jquery';
import _ from 'underscore';

import {Sequence} from 'components/Sequence';
import * as CRISPRConstants from 'constants/CRISPRConstants';
import {CRISPRAnalysis, CRISPRGuide} from 'constants/CRISPRConstants';
import {SliceComponentName, SliceMapType} from 'constants/MapsConstants';
import {StrandOfDoubleStranded} from 'constants/MolbioConstants';
import SearchDNAData from 'molbio/biological-search/SearchDNAData';
import CRISPRDefaults from 'molbio/crispr/CRISPRDefaults';
import * as CRISPRUtil from 'molbio/crispr/CRISPRUtil';
import Component, {ComponentOptions} from 'molbio/maps/linear/Component';
import {LinearLayout, PAMSites as PAMSitesLayout} from 'molbio/maps/linear/LinearLayout';
import Slice from 'molbio/maps/linear/Slice';
import {SliceView} from 'molbio/maps/linear/SliceView';
import * as mapsutil from 'molbio/maps/MapsUtil';
import * as sequtil from 'molbio/SeqUtil';
import {TabState} from 'Navigation';
import preferences from 'Preferences';
import pick from 'util/pick';

interface PAMSiteRange {
  start: number;
  end: number;
  showOnTarget: boolean;
  showOffTarget: boolean;
  showGuide: boolean;
}

class PAMSite extends Backbone.Model {
  strand(): StrandOfDoubleStranded | null {
    return this.guide().strand;
  }

  pos(): number {
    if (this.analysis().isLeftPam) {
      if (this.guide().strand === 1) {
        return this.start() + CRISPRConstants.LEFT_PAM_TO_CUT_DISTANCE;
      } else {
        return this.end() - CRISPRConstants.LEFT_PAM_TO_CUT_DISTANCE;
      }
    } else if (this.guide().strand === 1) {
      return this.end() - CRISPRConstants.PAM_TO_CUT_DISTANCE;
    } else {
      return this.start() + CRISPRConstants.PAM_TO_CUT_DISTANCE;
    }
  }

  onTargetScore(): number | null {
    const onTargetScore = this.guide().onTargetScore;
    if (onTargetScore != null) {
      return Math.floor(onTargetScore);
    }
    return null;
  }

  offTargetScore(): number | null {
    const offTargetScore = this.guide().offTargetScore;
    if (offTargetScore != null) {
      return Math.floor(offTargetScore);
    }
    return null;
  }

  guide(): CRISPRGuide {
    return this.get('guide');
  }

  sequence(): Sequence {
    return this.get('sequence');
  }

  analysis(): CRISPRAnalysis {
    return this.get('analysis');
  }

  start(): number {
    return CRISPRUtil.guideStart(this.guide(), this.sequence().length(), this.analysis().isLeftPam);
  }

  end(): number {
    return CRISPRUtil.guideEnd(this.guide(), this.sequence().length(), this.analysis().isLeftPam);
  }
}

class PAMSites extends Backbone.Collection<PAMSite> {
  static initClass(): void {
    this.prototype.model = PAMSite;
  }
}
PAMSites.initClass();

export interface PAMSitesViewOptions extends ComponentOptions {
  componentClassName: SliceComponentName;
  mapType: SliceMapType;
  parent: SliceView;
  slice: Slice;
  strand: StrandOfDoubleStranded;
}

interface PAMSitesViewDatum {
  model: PAMSite;
  layer: number;
  range: PAMSiteRange;
}

class PAMSitesView extends Component {
  componentClassName!: SliceComponentName;
  _layout!: LinearLayout;
  layout!: PAMSitesLayout;
  max!: number;
  parent!: SliceView;
  search!: SearchDNAData;
  sites!: PAMSites;
  slice!: Slice;
  strand!: StrandOfDoubleStranded;
  tabstate!: TabState;

  static override initClass(): void {
    this.prototype.className = 'pamSites';
  }

  override initialize(options: PAMSitesViewOptions): void {
    ({
      tabstate: this.tabstate,
      slice: this.slice,
      strand: this.strand,
      parent: this.parent,
      componentClassName: this.componentClassName,
    } = options);
    this._renderPamSite = this._renderPamSite.bind(this);
    this.className += ` ${this.componentClassName}`;

    this._layout = this.model.get('layout');
    this.layout = this._layout.PAMSites;
    this.sites = new PAMSites();
    this.search = new SearchDNAData();
    const sequence = this.model.get('sequence');
    this.search.addSequences([sequence]);
    this.search.set({sequence});

    super.initialize(options);
  }

  override registerListeners(): void {
    super.registerListeners();
    this.listenTo(this.layout, 'change:analysis', function () {
      // @ts-expect-error shadows outer this
      this.update();
    });
    this.listenTo(this.slice, 'change:start change:end', function () {
      // @ts-expect-error shadows outer this
      this.update();
    });
    const key = CRISPRDefaults.KEYS.SHOW_CUTS_OUTSIDE_REGIONS;
    this.listenTo(preferences, `change:${CRISPRDefaults.getKey(key)}`, function () {
      // @ts-expect-error shadows outer this
      this.update();
    });
  }

  override boxHeight(): number {
    if (this.shouldShow()) {
      return this.layout.boxHeight({overlap: this.max + 1});
    } else {
      return 0;
    }
  }

  _computeSites(): void {
    // Search for guides over the slice using the analysis parameters.
    const sequence = this.model.get('sequence');
    const analysis = this.layout.get('analysis')!;

    // In case the guide goes off the slice, we still want to render the pam site.
    // TODO: Handle circular case correctly.
    const guidePadding = analysis.guideLength + analysis.pam.length;
    const start = Math.max(this.slice.start() - guidePadding, 0);
    const end = Math.min(this.slice.end() + guidePadding, sequence.length());

    let _guides = CRISPRUtil.findGuidesInRange(sequence, this.search, analysis, start, end, this.strand);
    _guides = CRISPRUtil.filterGuides(sequence, analysis, _guides, {
      skipTypeFilter: true,
      skipCutsOutsideRegions: !CRISPRDefaults.get(CRISPRDefaults.KEYS.SHOW_CUTS_OUTSIDE_REGIONS),
    });

    // Filter pam sites that are not on the slice
    _guides = _guides.filter((guide) =>
      sequtil.baseInRange(guide.position, this.slice.start(), this.slice.end())
    );

    // Use existing guide if it exists since it has scoring information, otherwise use newly created one.
    this.sites.reset(
      // @ts-expect-error `reset` expects Backbone models, and we're giving it the models' attributes instead
      _guides.map((_guide) => {
        let guide;
        for (const region of Array.from(analysis.regions)) {
          guide = _.findWhere(region.guides, pick(_guide, 'position', 'strand'));
          if (guide != null) {
            return {guide, sequence, analysis};
          }
        }
        return {guide: _guide, sequence, analysis};
      })
    );
  }

  _renderPamSite(root: d3.Selection<d3.BaseType, PAMSitesViewDatum, d3.BaseType, unknown>): void {
    const baseToX = this.slice.x();
    const scoreToColor = this.layout.get('scoreToColor');
    const type = this.layout.get('type');
    const analysis = this.layout.get('analysis')!;

    // Determine layering depending on above/below DNA.
    const lineHeight = this.layout.get('lineHeight');
    const maxHeight = this.layout.height({overlap: this.max + 1});
    const aboveDNA = this.parent.yIndexMap[this.componentClassName]! < this.parent.yIndexMap.dna!;
    const layerTop = d3.scaleLinear().domain([0, this.max]);
    if (aboveDNA) {
      layerTop.range([0, this.layout.height({overlap: this.max})]);
    } else {
      layerTop.range([this.layout.height({overlap: this.max}) + lineHeight, lineHeight]);
    }

    // Determine bounds of line that gets drawn from DNA
    const dnaLayout = this._layout.DNA;
    let dnaDist = this.parent.boxHeightToDNA(this.componentClassName);
    if (dnaLayout.get('visible')) {
      dnaDist += dnaLayout.vMargin() + dnaLayout.get('type').verticalOffset;
    }
    const yAtSite = aboveDNA ? type.height() : 0;

    function yAtDNA(layer: number): number {
      if (aboveDNA) {
        return -layerTop(layer) + maxHeight + dnaDist + lineHeight;
      } else {
        return -layerTop(layer) - dnaDist;
      }
    }

    root.attr('transform', ({layer}: {layer: number}) => `translate(0, ${layerTop(layer)})`);

    // Draw line from base.
    root
      .select('.pamSite-line')
      .attr('d', ({model, layer}) => {
        const x = baseToX(model.pos());
        return `M ${x} ${yAtDNA(layer)} L ${x} ${yAtSite}`;
      })
      .attr('fill', 'none')
      .attr('visibility', ({range}) => {
        if (range.showGuide) {
          return 'visible';
        } else {
          return 'hidden';
        }
      });

    // Draw rectangles
    const scoreToBorderColor = (score: number): d3.RGBColor => d3.rgb(scoreToColor(score)).darker(0.6);
    root
      .selectAll('.pamSite-score-rect')
      .attr('height', type.height())
      .attr('stroke-width', 1)
      .attr('stroke', 'black');
    const onG = root
      .select('.pamSite-score--on')
      .attr('visibility', ({range}) => {
        if (range.showGuide && range.showOnTarget) {
          return 'visible';
        } else {
          return 'hidden';
        }
      })
      .attr('transform', ({range}) => `translate(${range.start}, 0)`);
    onG
      .select('.pamSite-score-rect')
      .attr('width', () => this.layout.scoreWidth())
      // @ts-expect-error d3 type version skew this really does accept a d3.rgb for a stroke
      .attr('stroke', ({model}: {model: PAMSite}) => scoreToBorderColor(model.onTargetScore()!))
      .attr('fill', ({model}: {model: PAMSite}) => scoreToColor(model.onTargetScore()!));
    const offG = root
      .select('.pamSite-score--off')
      .attr('visibility', ({range}: {range: PAMSiteRange}) =>
        range.showOffTarget && range.showGuide ? 'visible' : 'hidden'
      )
      .attr('transform', ({range}: {range: PAMSiteRange}) => {
        if (range.showOnTarget) {
          return `translate(${range.start + this.layout.scoreWidth()}, 0)`;
        } else {
          return `translate(${range.start}, 0)`;
        }
      });
    offG
      .select('.pamSite-score-rect')
      .attr('width', ({model}: {model: PAMSite}) => {
        if (analysis.isLeftPam && model.offTargetScore() == null) {
          return this.layout.leftPamBoxWidth();
        } else {
          return this.layout.scoreWidth();
        }
      })
      // @ts-expect-error d3 type version skew this really does accept a d3.rgb for a stroke
      .attr('stroke', ({model}) => {
        if (analysis.isLeftPam && model.offTargetScore() == null) {
          return this.layout.get('grayColor');
        } else {
          return scoreToBorderColor(model.offTargetScore()!);
        }
      })
      .attr('fill', ({model}: {model: PAMSite}) => {
        if (analysis.isLeftPam && model.offTargetScore() == null) {
          return this.layout.get('grayColor');
        } else if (model.offTargetScore() != null) {
          return scoreToColor(model.offTargetScore()!);
        } else {
          return this.layout.get('loadingColor');
        }
      });

    // Draw labels
    const updateScores = (
      selector: d3.Selection<d3.BaseType, PAMSitesViewDatum, d3.BaseType, unknown>
    ): void => {
      selector
        .attr('text-anchor', 'middle')
        .attr('font-size', type.fontSize)
        .attr('dy', type.height() - 3)
        .attr('x', ({model}: {model: PAMSite}) => {
          if (analysis.isLeftPam && model.offTargetScore() == null) {
            return this.layout.leftPamTextOffset();
          } else {
            return this.layout.textOffset();
          }
        });
    };

    onG
      .select('.pamSite-score-label')
      .call(updateScores)
      .text(({model}) => {
        if (analysis.isLeftPam) {
          return 'Cpf1';
        } else if (model.onTargetScore() != null) {
          return model.onTargetScore();
        } else {
          return '';
        }
      });
    offG
      .select('.pamSite-score-label')
      .call(updateScores)
      .text(({model}) => {
        if (model.offTargetScore() != null) {
          return model.offTargetScore();
        } else if (analysis.isLeftPam) {
          return 'Cpf1';
        } else {
          return '';
        }
      });
  }

  _siteRange(site: PAMSite): PAMSiteRange {
    let showGuide, showOffTarget, showOnTarget;
    const baseToX = this.slice.x();
    const maxWidth = this.slice.get('maxWidth')!;
    const hMargin = this.layout.get('hMargin');
    if (this.layout.get('analysis')!.isLeftPam) {
      // For Cpf1 we only have offTarget scores but no onTarget scores
      showOnTarget = false;
      showOffTarget = true;
      showGuide = true;
    } else {
      showOnTarget =
        this.layout.pamSiteOnTargetMin() == null || site.onTargetScore()! > this.layout.pamSiteOnTargetMin()!;

      // showOffTargetScore if it exists and (there is no minimum or it is larger than the minimum)
      showOffTarget =
        site.offTargetScore() != null &&
        (this.layout.pamSiteOffTargetMin() == null ||
          site.offTargetScore()! > this.layout.pamSiteOffTargetMin()!);

      // showGuide if we are showing onTarget and either offTarget doesn't exists or it is valid
      showGuide = showOnTarget && (site.offTargetScore() == null || showOffTarget);
    }

    const width = this.layout.scoreWidth() * _.compact([showOnTarget, showOffTarget]).length;

    const middleX = baseToX(site.pos());
    let startX = middleX - width / 2;
    if (startX <= 0) {
      startX = 0;
    } else if (startX + width > maxWidth) {
      startX = maxWidth - width;
    }

    return {start: startX, end: startX + width + hMargin, showOnTarget, showOffTarget, showGuide};
  }

  override die(): void {
    d3.select(this.el)
      .selectAll('.pamSite-score')
      .each(function () {
        // @ts-expect-error TS is not recognizing that `this` from within the chain is still the score $el
        $(this).tooltip('destroy');
      });
    super.die();
  }

  // updateForAdjust is called on a list of slices in a loop in SliceView
  updateForAdjust(): void {
    this.update(false, false);
  }

  // TODO(T2660): Fix recompute/rerender logic.
  update(trigger: boolean = true, recompute: boolean = true): void {
    let layers: Array<PAMSitesViewDatum>;
    if (
      !this.shouldShow() ||
      (!recompute && this.model.get('sequence').length() === 0) ||
      __guard__(this.layout.get('analysis'), (x) => x!.designType) === 'base_edit'
    ) {
      return;
    }

    // Compute PAM sites
    if (recompute) {
      if (this.layout.pamSiteOnTargetMin() != null || this.layout.pamSiteOffTargetMin() != null) {
        this._computeSites();
      } else if (this.sites.length !== 0) {
        this.sites.reset();
      } else {
        // Despite the following code handling the case where we update from 0 sites to 0 sites, we avoid a
        // performance hit from d3.
        return;
      }
    }

    // Compute layering
    const siteRanges: {[cid: string]: PAMSiteRange} = {};
    this.sites.forEach((site) => (siteRanges[site.cid] = this._siteRange(site)));
    const visibleSites = this.sites.filter((site) => siteRanges[site.cid].showGuide);
    // @ts-expect-error `PAMSite` is not a `Layer`, but we override the `Layer`-necessitating functionality by
    // passing in startFn and endFn ourselves.
    ({layers, max: this.max} = mapsutil.getLayers(visibleSites, {
      startFn(model: PAMSite) {
        return {model, pos: siteRanges[model.cid].start};
      },
      endFn(model: PAMSite) {
        return {model, pos: siteRanges[model.cid].end};
      },
    }));

    // Render
    const data: Array<PAMSitesViewDatum> = _.sortBy(layers, 'layer').map(({model, layer}) => ({
      model,
      layer,
      range: siteRanges[model.cid],
    }));
    const root = d3.select(this.el).select('.component-wrapper').selectAll('.pamSite').data(data);

    // enter
    function enterScoreG(
      selector: d3.Selection<d3.BaseType, PAMSitesViewDatum, d3.BaseType, unknown>,
      title: string,
      type: string
    ): void {
      selector.attr('class', `pamSite-score pamSite-score--${type}`);
      selector.append('svg:rect').attr('class', 'pamSite-score-rect');
      selector.append('svg:text').attr('class', 'pamSite-score-label');
      selector.each(function () {
        // @ts-expect-error shadows outer this
        $(this).tooltip({
          delay: {show: 500, hide: 0},
          trigger: 'hover',
          placement: 'top',
          container: 'body',
          title,
        });
      });
    }

    const enter = root.enter().append('svg:g').attr('class', 'pamSite');
    enter.append('svg:path').attr('class', 'pamSite-line');
    enter.append('svg:g').call(enterScoreG, 'On-Target', 'on');
    enter.append('svg:g').call(enterScoreG, 'Off-Target', 'off');
    enter.append('svg:text').attr('class', 'pamSite-label');
    enter.on('mousedown', (e, {model}) => {
      e.stopPropagation();
      this.model.get('sequence').selection().setEndpoints(model.start(), model.end());
    });
    // exit
    root
      .exit()
      .each(function () {
        return d3
          .select(this)
          .selectAll('.pamSite-score')
          .each(function () {
            // @ts-expect-error TS is not recognizing that `this` from within the chain is still the score $el
            $(this).tooltip('destroy');
          });
      })
      .remove();
    // eslint-disable-next-line @typescript-eslint/unbound-method
    root.call(this._renderPamSite);

    if (trigger) {
      this.trigger('redraw');
    }
  }
}
PAMSitesView.initClass();

export default PAMSitesView;

function __guard__<TValue, TReturn>(
  value: TValue,
  transform: (value: TValue) => TReturn
): TReturn | undefined {
  return value != null ? transform(value) : undefined;
}
